<app-breadcrumb [links]="[{link: 'admin', name: 'Administração'}]" current="Noticias"></app-breadcrumb>
<div class="backgroundColor star-dust darken-3">
  <section class="container-fluid backgroundColor star-dust darken-3 position-relative top-119" id="my-element">
    <div class="container mb-5">
      <div class="row pt-20 pb-10 d-flex justify-content-center">
        <div class="col-6">
          <h1 class="text-white text-shadow">Inserir Notícias</h1>
        </div>
      </div>
      <div class="row mt-20 d-flex justify-content-between">
        <div class="col-12 col-md-4 col-lg-4 fixedHeight">
          <ng-container *ngFor="let item of noticias">
            <div class="row d-flex justify-content-center mb-2">
              <div class="card p-4 d-flex justify-content-center model-border" style="width:350px;">
                <div class="mx-auto">
                  <img src="https://{{apiUrl}}/api/news/image/{{item.id}}/{{item.media.split(';')[0]}}" alt="..." class="img-fluid my-auto">
                </div>
                <div class="card-body">
                  <h1 class="my-auto card-title text-white card-text-limit font-italic">{{item.titulo}}</h1>
                  <p class="text-white text-justify card-text-limit">{{item.body}}</p>
                  <div class="">
                    <button class="btn harvest-gold base card-link" (click)="delete(item)"><fa-icon [icon]="faTrash" class="fal fa-trash"></fa-icon></button>
                    <button class="btn shark lighten-3 card-link" (click)="bindNews(item)"><fa-icon [icon]="faPencilAlt" class="fal fa-pencil-alt"></fa-icon></button>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="col-12 col-sm-12 col-md-7 col-lg-6 backgroundColor shark base py-10">
          <div class="form-group">
            <label class="text-white">Título</label>&nbsp;
            <input class="form-control" type="text" [(ngModel)]="model.titulo">
          </div>
          <div class="form-group">
            <label class="text-white">Texto</label>&nbsp;
            <textarea class="form-control" rows="6" type="text" [(ngModel)]="model.body"></textarea>
          </div>
          <app-imageInput class="text-white " titulo="Imagens" btn="Ficheiros" [(models)]="model.media" [multiple]="true"></app-imageInput>
          <button type="submit" class="btn harvest-gold mr-24  position-absolute btn-pos" (click)="sendNoticia()">Submeter</button>
          <button type="submit" class="btn btn-secondary position-absolute btn-pos" (click)="clearNoticia()">Cancelar</button>
        </div>
      </div>
    </div>
  </section>
</div>